function parseSiblingImages(raw) {
  if (!raw) return [];
  return raw.split('|||').filter(Boolean);
}

function preloadSiblingImages(items) {
  items.forEach((item) => {
    parseSiblingImages(item.getAttribute('data-hover-images')).forEach((url) => {
      const image = new Image();
      image.src = url;
    });
  });
}

function getGalleryImages(sectionId) {
  const section = document.getElementById(`shopify-section-${sectionId}`);
  const gallery = section?.querySelector('product-gallery');

  if (!gallery) return [];

  return Array.from(gallery.querySelectorAll('.product-gallery__media:not([hidden]) img'));
}

function snapshotGalleryImages(images) {
  return images.map((image) => ({
    src: image.currentSrc || image.src,
    srcset: image.srcset,
    sizes: image.sizes
  }));
}

function swapGalleryImages(images, urls) {
  images.forEach((image, index) => {
    const nextUrl = urls[index] || urls[urls.length - 1] || urls[0];

    if (!nextUrl) return;

    image.src = nextUrl;
    image.srcset = '';
    image.sizes = '';
  });
}

function restoreGalleryImages(images, snapshots) {
  images.forEach((image, index) => {
    const snapshot = snapshots[index];

    if (!snapshot) return;

    image.src = snapshot.src;
    image.srcset = snapshot.srcset;
    image.sizes = snapshot.sizes;
  });
}

function initSiblingHoverEffect() {
  document.querySelectorAll('[data-siblings-grid]').forEach((grid) => {
    if (grid.dataset.siblingsHoverInit === 'true') return;

    grid.dataset.siblingsHoverInit = 'true';

    const sectionId = grid.getAttribute('data-siblings-section-id');
    const colorDisplay = document.querySelector(`[data-color-display="${sectionId}"]`);
    const galleryImages = getGalleryImages(sectionId);
    const originalColor = colorDisplay?.textContent?.trim() || '';
    const originalSnapshots = snapshotGalleryImages(galleryImages);
    const hoverItems = grid.querySelectorAll('.product-siblings-item[data-sibling-color]:not(.product-siblings-item--active)');

    preloadSiblingImages(grid.querySelectorAll('[data-hover-images]'));

    hoverItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        const hoverColor = item.getAttribute('data-sibling-color');
        const urls = parseSiblingImages(item.getAttribute('data-hover-images'));

        if (colorDisplay && hoverColor) {
          colorDisplay.textContent = hoverColor;
        }

        if (galleryImages.length && urls.length) {
          swapGalleryImages(galleryImages, urls);
        }
      });

      item.addEventListener('mouseleave', () => {
        if (colorDisplay) {
          colorDisplay.textContent = originalColor;
        }

        if (galleryImages.length) {
          restoreGalleryImages(galleryImages, originalSnapshots);
        }
      });
    });
  });
}

window.openProductSiblingsDrawer = function openProductSiblingsDrawer(productId, sectionId) {
  const drawer = document.getElementById('product-siblings-drawer');
  const dataElement = document.querySelector(`[data-siblings-data="${productId}-${sectionId}"]`);
  const grid = drawer?.querySelector('[data-siblings-drawer-grid]');

  if (!drawer || !dataElement || !grid) return;

  grid.innerHTML = dataElement.innerHTML;
  drawer.show();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSiblingHoverEffect);
} else {
  initSiblingHoverEffect();
}

document.addEventListener('shopify:section:load', initSiblingHoverEffect);
document.addEventListener('variant:change', () => {
  window.requestAnimationFrame(initSiblingHoverEffect);
});
